// src/components/Snackbar/useSnackbar.tsx
import React, {
  createContext,
  useContext,
  useCallback,
  useState,
  ReactNode,
  FC,
} from 'react';
import Snackbar from "@/app/components/snackbar";

interface ContextValue {
  showMessage: (msg: string, duration?: number, error?: boolean) => void;
}

const SnackbarContext = createContext<ContextValue | null>(null);

export const SnackbarProvider: FC<{ children: ReactNode }> = ({children}) => {
  const [message, setMessage] = useState<string | null>(null);
  const [duration, setDuration] = useState(4000);
  const [isError, setIsError] = useState(false);

  const showMessage = useCallback((msg: string, dur = 4000, error = false) => {
    setMessage(msg);
    setDuration(dur);
    setIsError(error);
  }, []);

  const handleClose = () => {
    setMessage(null);
  };

  return (
    <SnackbarContext.Provider value={{showMessage}}>
      {children}
      <Snackbar message={message} duration={duration} onClose={handleClose} isError={isError}/>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = (): ContextValue => {
  const ctx = useContext(SnackbarContext);
  if (!ctx) throw new Error('useSnackbar must be used within SnackbarProvider');
  return ctx;
};
